import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import DateTimeIsForm from './DateTimeIsForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(DateTimeIsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/DateTimeIs/DateTimeIsForm.container.js